import React from "react";
import Wallets from "../../Component/Wallets";

const MainWallet = () => {
	return <Wallets />;
};

export default MainWallet;
